import { render, staticRenderFns } from "./HostButtons.vue?vue&type=template&id=e74839c6&"
import script from "./HostButtons.vue?vue&type=script&lang=js&"
export * from "./HostButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports